'use strict';

var $ = require('jquery');
var offcanvasdialog = require('../offcanvasdialog');
import wishlist from '../../pages/wishlist';
import {renderRecommendations} from '../../constructor-io/helpers/recommendations';
import {addToCartRecommendations} from '../../components/slickConfigs';
var cartoverlay;

cartoverlay = {
    show: function (html) {
        var dialog = offcanvasdialog.init(false, {
            position: document.documentElement.lang === 'ar' ? 'left' : 'right',
            overlay: true,
            closeOnX: true,
            additionalClass: 'add-to-cart-fly-in',
            headerStyle: 'over'
        });

        var isConstructorRecomm = $(html).find('.js-add-to-cart-recomm-constructor').length > 0;
        var isCQuotientRecomm =
            $(html).find('.add-to-cart-recommendations:not(.js-add-to-cart-recomm-constructor)').length > 0;

        var content = {
            html: html
        };

        dialog.loadContent(content, async function () {
            dialog.show();

            if (isConstructorRecomm) {
                var data = $(html).find('.added-product-details').data();
                let parentProductId = data.parentProductId;
                await renderRecommendations('add2cart', [parentProductId]);
            } else if (isCQuotientRecomm && 'MutationObserver' in window) {
                const reccomContainer = document.querySelector('.add-to-cart-recommendations');

                // Track the moment when the recommendations are added to the DOM to initialize the wishlist
                const observer = new MutationObserver(mutationsList => {
                    mutationsList.some(mutation => {
                        if (
                            mutation.addedNodes.length &&
                            $('.add-to-cart-recommendations .product-wishlist-link').length > 0
                        ) {
                            wishlist.init();
                            observer.disconnect();
                            return true;
                        }
                        return false;
                    });
                });

                observer.observe(reccomContainer, {
                    childList: true,
                    subtree: true
                });
            }

            wishlist.init();
        });
        let customEvent = new CustomEvent('optimizely:renderWidget', {
            detail: window.optimizelyJSONData
        });
        document.dispatchEvent(customEvent);
    },

    init: function () {
        $('body').on('click', '.shopping-link-trigger', function () {
            offcanvasdialog.closeAll();
        });
    },

    slickRecomm: function () {
        addToCartRecommendations();
    }
};

module.exports = cartoverlay;
